import { IAPIResponse } from '@/api/interfaces/api';
import { AppAxios } from '@/typings/global.interfaces';

export enum FaqType {
    ANSWEAR_CLUB = '/answearClub',
}

export interface IFaqItem {
    question: string;
    answer: string;
    pdfPath: string;
    id: number;
}

export interface IFaqItems {
    title: string;
    iconPath: string;
    items: IFaqItem[];
}

export interface IFaqResponse extends IAPIResponse {
    items: IFaqItems[];
}

export const Faq = {
    getContent: ($http: AppAxios, type?: FaqType) => {
        const url = type ? `/faq${type}` : '/faq';

        return $http.get<IFaqResponse>(url).then(res => res.data);
    },
};
